/**
 * Startup profile copy that is NOT already in `UI_STRINGS.STARTUP_PROFILE`
 * (MYN-101). Its own file rather than an addition to
 * `lib/constants/ui-strings.ts`: that file is at 607 lines, past the
 * mnr-standards 600-LOC red band ("do not merge, decompose before opening
 * PR") and already carries its own `TODO(decompose)` marker. Splitting a
 * 607-line shared file every screen imports is unrelated, out-of-scope work
 * for this ticket (BP-6), so new copy for this module lives locally instead
 * of growing it further - the same call `partner-profile.strings.ts` made.
 */
export const STARTUP_PROFILE_STRINGS = {
  COMPANY_LOGO: 'Company Logo',
  PITCH_VIDEO_URL_PLACEHOLDER: 'https://vimeo.com/your-pitch',
  // A deck IS attached but its download link could not be signed. Distinct
  // from NOT_ADDED so a founder is not told their upload vanished.
  LINK_UNAVAILABLE: 'Link temporarily unavailable',
  // Profile header and cards (MYN-217, profile-redesign FR-170 to FR-172),
  // worded as in the client-approved mockup.
  FOUNDED: (year: number) => `Founded ${year}`,
  RAISING: 'Raising',
  ARR: 'ARR',
  RAISED_TO_DATE: 'Raised to date',
  TEAM: 'Team',
  TEAM_SIZE: (count: number) => `${count} ${count === 1 ? 'person' : 'people'}`,
  LINKEDIN: 'LinkedIn',
  COMPANY_DETAILS: 'Company details',
  /** Admins could not find where the logo is edited (UX round 3, StartupAdminPatty P34). */
  COMPANY_DETAILS_LOGO_HINT: 'Your company logo, name and description are edited here too. Click Edit.',
  CURRENT_RAISE: 'Current raise',
  FOUNDING_TEAM: 'Founding team',
  PITCH_MATERIALS: 'Pitch materials',
  FINANCIALS: 'Financials',
  FUNDING_STAGE: 'Funding stage',
  YEAR_FOUNDED: 'Year founded',
  EMPLOYEES: 'Employees',
  REGION: 'Region',
  MARKET_MODEL: 'Market model',
  AI_CLASSIFICATION: 'AI classification',
  RECENT_MILESTONE: 'Recent milestone',
  ROUND_SIZE: 'Round size',
  INSTRUMENT: 'Instrument',
  VALUATION_OR_CAP: 'Valuation or cap',
  TARGET_CLOSE: 'Target close',
  LEAD_INVESTOR: 'Lead investor',
  LEAD_NO: 'No',
  LEAD_CONFIRMED: 'Confirmed',
  INVESTOR_TYPES_SOUGHT: 'Investor types sought',
  USE_OF_FUNDS: 'Use of funds',
  TOTAL_REVENUE: 'Total revenue',
  NONDILUTIVE_FUNDING: 'Non-dilutive funding',
  REVENUE_MODEL: 'Revenue model',
  REVENUE_GROWTH: 'Revenue growth',
  PAYING_CUSTOMERS: 'Paying customers',
  PAST_EXIT: 'Past exit',
  NO_TEAM: 'No team members added yet.',
  DECK_THUMB: 'DECK',
  PITCH_DECK: 'Pitch deck',
  PITCH_VIDEO: 'Pitch video',
} as const;
